import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ProblemDescription } from '@/domain/entities/problem/problemDescription'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ProblemDescriptionModuleName } from '@/store/modules/modules'

export class ProblemDescriptionViewModel {
  private store = useStore()

  problemDescription: ComputedRef<ProblemDescription> = computed(
    () => this.store.getters[`${ProblemDescriptionModuleName}/problemDescription`]
  )

  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${ProblemDescriptionModuleName}/isLoading`])

  error: ComputedRef<string | null> = computed(() => this.store.getters[`${ProblemDescriptionModuleName}/error`])

  async getProblemDescription(displayLanguage: DisplayLanguageType, problemId: string): Promise<void> {
    await this.store.dispatch(`${ProblemDescriptionModuleName}/getProblemDescription`, { displayLanguage, problemId })
  }
}
